import { ColDef, ColGroupDef } from 'ag-grid-enterprise'

import { CustomAgGridProps } from '@fortem-monorepo/react-ag'
import { ContentBlocks, DataGridRow } from '@fortem-monorepo/web-sdk'

import { ContentBlockRenderContext } from '@/components/content-blocks/context'

export type DataGridContentBlock<TRow extends DataGridRow = DataGridRow> =
  ContentBlocks.DataGridContentBlock<TRow>

export type DataGridColumnDef<TRow extends ContentBlocks.DataGridRow = ContentBlocks.DataGridRow> =
  ColDef<TRow> | ColGroupDef<TRow>

export type DataGridBlockOverrideConfig<
  TRow extends ContentBlocks.DataGridRow = ContentBlocks.DataGridRow,
> = {
  transformRows?: (rows: TRow[], block: ContentBlocks.DataGridContentBlock<TRow>) => TRow[]
  columnDefs?: DataGridColumnDef<TRow>[]
  gridProps?: Partial<CustomAgGridProps>
}

export type DataGridBlockOverride<
  TRow extends ContentBlocks.DataGridRow = ContentBlocks.DataGridRow,
> = (
  context: ContentBlockRenderContext,
  block: ContentBlocks.DataGridContentBlock<TRow>,
) => DataGridBlockOverrideConfig<TRow>

export type AnyDataGridBlockOverride = DataGridBlockOverride<ContentBlocks.DataGridRow>

export type DataGridBlockOverrides<TBlockId extends string = string> = Partial<
  Record<TBlockId, AnyDataGridBlockOverride>
>

export const dataGridOverride = <
  TRow extends ContentBlocks.DataGridRow = ContentBlocks.DataGridRow,
>(
  override: DataGridBlockOverride<TRow>,
): AnyDataGridBlockOverride => override as AnyDataGridBlockOverride
